import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { Subject } from "rxjs";
import { ModalPage } from "src/app/modals/modal/modal.page";
import { ModalComponent } from "src/app/modals/modal/modal.component";
import { AppHeaderService } from "../../header/app-header/app-header.service";

export interface LessonSettings {
  passrate: number;
  sapcode: string;
  maxattempts: number;
  validitymonths: number;
  trainingarea: string;
  trainingarea_guid: string;
  active: boolean;
  induction: boolean;
  randomised: boolean;
  allowlearning: boolean;
  issurvey: boolean;
  skipquestionreview: boolean;
  skipaudiofeedback: boolean;
  showlessoncontent: boolean;
  Lessoncontent_guid: string;
}

@Component({
  selector: "app-datepicker-modal",
  templateUrl: "./LessonParameter-modal.page.html",
  styleUrls: ["./LessonParameter-modal.page.scss"],
})
export class LessonParameterModalPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  Vendor_GUID: string;
  LessonParameterList: any;
  LessonParameterSelectedList: any;
  loadingDone: boolean = false;
  searchText: string = "";
  //LessonSettings:LessonSettings;
  LessonSettings: any;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global,
    private appHeaderService: AppHeaderService
  ) {
    //defaults
    // this.LessonSettings = {   passrate: 100,
    //                           sapcode:'',
    //                           maxattempts:1,
    //                           validitymonths:12,
    //                           trainingarea:'',
    //                           trainingarea_guid:'',
    //                           active:true,
    //                           induction:false,
    //                           randomised:false,
    //                           allowlearning:true,
    //                           issurvey:false,
    //                           skipquestionreview:false,
    //                           skipaudiofeedback:false,
    //                           Lessoncontent_guid:''
    //                         };
  }

  ngOnInit() {
    this.callingFilter = this.navParams.data.paramObject.callingFilter;
    this.User_GUID = this.navParams.data.paramObject.User_GUID;
    this.Vendor_GUID = this.navParams.data.paramObject.Vendor_GUID;
    this.LessonSettings = this.navParams.data.paramObject.LessonSettings;

    //this.GetLessonSettings();
    this.loadingDone = true;
  }

  async onLessonParameterSelect(event: any, LessonParameter: any) {
    await this.modalCtrl.dismiss(LessonParameter);
  }

  async onUploadContentClick(
    event: any,
    key: any,
    Content_GUID: any,
    modalHeading: any
  ) {
    var paramObject = {
      modalType: "Upload",
      modalBodyText: "",
      modalHeaderText: modalHeading,
      Content_GUID: Content_GUID,
    };

    const modal = await this.modalCtrl.create({
      component: ModalPage,
      componentProps: {
        paramObject: paramObject,
      },
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
        this.LessonSettings[key] = dataReturned.data.GUID;
      }
    });
    return await modal.present();
  }

  GetLessonSettings() {
    // var subject = new Subject<any>();
    // const formData: FormData = new FormData();
    // formData.append('UserToken', this.globals.XRSUser.UserToken);
    // formData.append('GUID', this.globals.XRSUser.GUID);
    // formData.append('Vendor_GUID', this.Vendor_GUID);
    // formData.append('search', this.searchText);
    // formData.append('filter', "AllLessonParameter");
    // formData.append('sort', "Created");
    // formData.append('take', ""+20);
    // formData.append('skip', "" + 0);
    // formData.append('callingFilter', '' + this.callingFilter);
    // formData.append('User_GUID', '' + this.User_GUID);
    // formData.append('referancePage', "Scope of Work");
    // this.appservice.GetProcedureList(formData).subscribe(res => {
    //   try {
    //     this.loadingDone = true;
    //     this.LessonParameterList = (JSON.parse(res.toString()));
    //   } catch (e) {
    //   }
    // });
    // return subject.asObservable();
  }

  async closeModal() {
    await this.modalCtrl.dismiss(this.LessonSettings);
  }

  async onCloseUpload() {
    await this.modalCtrl.dismiss(this.LessonSettings);
  }

  // public onPagesLoaded(pagecount: PagesLoadedEvent): void {
  //   //this.TotalPages = pagecount.pagesCount;
  // }

  // public onPageRendered(pageRendered: PageRenderedEvent): void {
  //   //this.CurrentPage = pageRendered.pageNumber;
  // }
}
